function getContextFromUrl() {
  // get from URL query
  let loc = window.location.href;
  let ageContext = '';
  if (loc.includes('age_context=')) {
    let query = loc.substring(loc.indexOf('age_context='), loc.length);
    if (query.includes('&')) {
      ageContext = query.substring(0, query.indexOf('&'));
    } else {
      ageContext = query;
    }
  }
  // ageContext.replace('age_context=', '');

  return ageContext.replace('age_context=', '');
}

function getContextFromStorage() {
  // get from session storage
  return window.sessionStorage.getItem('age-context');
}

function setAgeContext(ageContext) {
  // set context in session storage
  window.sessionStorage.setItem('age-context', ageContext);
  console.log('Age context changed to: ', ageContext);
}

function addContextToLinks() {
  // skip on index??
  let ageContext = getContextFromUrl() || getContextFromStorage();
  if (ageContext == 'womens') ageContext = 'women';
  if (ageContext == 'mens') ageContext = 'men';
  if (ageContext) {
    let pageLinks = document.querySelectorAll('a');
    pageLinks.forEach(pl => {
      // omit nav links
      if (!pl.closest('[data-nav]')) {
        if (pl.href.includes('/collections') || pl.href.includes('/products')) {
          pl.href.includes('?')
            ? (pl.href += `&age_context=${ageContext}`)
            : (pl.href += `?age_context=${ageContext}`);
        }
      } else {
        // Nav links are set by their respective sections
      }
    });
  }
}

// addContextQuery()
